/* ElitePetToys - Warenkorb-Zaehler im Header ein- und ausblenden.

   Die Vorlagen (templates/index.liquid, templates/product.ep.liquid) rendern
   den Button als

     <button class='cart-btn' onclick='openCart()'>Warenkorb <span class='cc' id='cc'>0</span></button>

   Wort und Badge bleiben genau so stehen, wie die Vorlage sie ausgibt -
   "Warenkorb" plus Zaehler-Badge dahinter. Dieses Skript macht nur eines:
   Solange der Warenkorb leer ist, blendet es das Badge aus, weil eine Null
   im Zaehler nach Fehler aussieht. Sobald etwas drin liegt, kommt es mit der
   Anzahl zurueck.

   Die Zaehler-Logik selbst (render(), loadCart() in den Vorlagen) schreibt
   unveraendert in #cc - hier wird nichts nachgerechnet und nichts umgebaut.
   Ohne JavaScript bleibt schlicht der Zaehler dauerhaft sichtbar. */
(function () {
  var MAX_VERSUCHE = 25;
  var versuche = 0;

  function anzahl(el) {
    var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function sichtbarkeit(el) {
    el.style.display = anzahl(el) > 0 ? '' : 'none';
  }

  function starten() {
    var btn = document.querySelector('.cart-btn');
    var zaehler = btn ? btn.querySelector('.cc') : null;

    if (!zaehler) {
      /* Der Header steht in der Vorlage weit oben, ist also normalerweise da.
         Seiten ohne eigenes Layout (z. B. die Richtlinienseiten) haben den
         Button gar nicht - deshalb nach ein paar Versuchen aufgeben. */
      versuche++;
      if (versuche <= MAX_VERSUCHE) { window.setTimeout(starten, 200); }
      return;
    }

    btn.setAttribute('aria-label', 'Warenkorb öffnen');

    sichtbarkeit(zaehler);
    try {
      new MutationObserver(function () { sichtbarkeit(zaehler); }).observe(zaehler, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) { /* aeltere Browser: Badge bleibt dann immer sichtbar */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
